import { PendencyTypes } from './types'

export function convertNameToTitleCase(name: string) {
  const lowercaseWords = ['de', 'da', 'do', 'das', 'dos']
  const words = name?.toLowerCase().split(' ')

  for (let i = 0; i < words?.length; i++) {
    const word = words[i]
    if (!lowercaseWords.includes(word) || i === 0) {
      words[i] = word.charAt(0).toUpperCase() + word.slice(1)
    }
  }

  return words?.join(' ')
}

export function getPendencyTitle(surgicalPendency: any) {
  switch (surgicalPendency?.type) {
    case PendencyTypes.HELP_CARD:
      return `Preciso de ajuda ${(
        '000' + surgicalPendency.surgical_pendency_order_id
      ).slice(-3)}`

    case PendencyTypes.AUTHORIZED_COMMUNICATION:
      return 'Comunicar Autorização'

    case PendencyTypes.DOCTOR_COMMUNICATION:
      return `Conversa ${(
        '000' + surgicalPendency.surgical_pendency_order_id
      ).slice(-3)}`

    default:
      return `Pendência ${(
        '000' + surgicalPendency.surgical_pendency_order_id
      ).slice(-3)}`
  }
}
